export default __webpack_public_path__ + "img/oKiMbXjD.125c01cf.svg";